export function getActionBarStyles(props) {
    const itemMargin = {
        marginRight: 8,
        marginBottom: 8,
    };
    const styles = {
        subComponentStyles: {
            primaryButton: (() => ({ root: [itemMargin] }))(),
            secondaryButton: (() => ({ root: [itemMargin] }))(),
        },
    };
    return styles;
}
//# sourceMappingURL=ActionBar.styles.js.map